var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoToIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 70,
    width: 70,
    height: 70,
    transform: "rotate(-90 0 70)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9899 25.7102L37.5242 34.2445L28.9685 42.8002C28.3438 43.4248 28.3438 44.4069 28.9685 45.0315C29.5931 45.6562 30.5752 45.6562 31.1998 45.0315L40.8547 35.3767C41.0055 35.2346 41.1254 35.0631 41.207 34.8726L40.7475 34.6757L41.207 34.8726C41.2599 34.7493 41.2959 34.6198 41.3144 34.4875L41.3504 34.4516L41.3504 34.2445C41.3504 33.8527 41.1893 33.4469 40.882 33.1395L31.2213 23.4788C30.5967 22.8542 29.6146 22.8542 28.9899 23.4788C28.3653 24.1035 28.3653 25.0856 28.9899 25.7102Z",
    fill: "#D75F04",
    stroke: "#D75F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToIcon);
export default __webpack_public_path__ + "static/media/go-to-icon.3a92b0ce27fa02500edccabd72a9d985.svg";
export { ForwardRef as ReactComponent };